import { createClient } from '@/shared/api';
import UPDATE_AFIB_HR_SUMMARY from '@/entities/heart-rate/api/mutations/updateAfibHrSummary';
import type {
  UpdateAfibHrSummaryMutation,
  UpdateAfibHrSummaryMutationVariables,
} from '@/shared/api/generated/graphql';

export type UpdateAfibHrSummaryResult = {
  isSuccess: boolean;
  message: string;
};

// TODO(ts): typed as the UpdateAfibHrSummaryInput GraphQL input once its server-side shape is documented
/**
 * Persists edits to a study's AFib heart-rate summary. Runs the updateAfibHrSummary mutation and throws the server message when it reports failure.
 *
 * @param input - Mutation input carrying the AFib summary edits.
 * @returns A promise resolving once the AFib summary has been saved.
 */
const handleUpdateAfibHrSummary = async (input: any) => {
  const client = await createClient();
  const result = await client.mutate<
    UpdateAfibHrSummaryMutation,
    UpdateAfibHrSummaryMutationVariables
  >({
    mutation: UPDATE_AFIB_HR_SUMMARY,
    variables: {
      input,
    },
  });
  const { data } = result;
  const { updateAfibHrSummary } = data;
  if (!updateAfibHrSummary.isSuccess) {
    throw new Error(updateAfibHrSummary.message);
  }
};

export default handleUpdateAfibHrSummary;
